import PendingTeamStepsVivokidChallengeRequests from 'collections/vivokidchallenge/PendingTeamStepsVivokidChallengeRequests';
import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import NavigationUtil from 'utils/NavigationUtil';
import Notifications from 'collections/notification/Notifications';
import PendingConnections from 'collections/connections/PendingConnections';
import PendingDeviceInviteRequests from 'collections/device/PendingDeviceInviteRequests';
import PendingChallengeInviteRequests from 'collections/adhocchallenge/PendingChallengeInviteRequests';
import PendingVivokidChallengeRequests from 'collections/vivokidchallenge/PendingVivokidChallengeRequests';
import UnreadBubble from 'models/notification/UnreadBubble';
import InboxRequests from 'models/notification/InboxRequests';
import InboxRequestCount from 'models/notification/InboxRequestCount';
import { REQUEST_KEY } from 'models/notification/inboxConstants';
import DeviceInviteRequest from 'models/device/DeviceInviteRequest';
import PendingConnectionItemView from 'views/notification/PendingConnectionItemView';
import PendingGroupRequestItemView from 'views/notification/PendingGroupRequestItemView';
import PendingWeightScaleRequestItemView from 'views/notification/PendingWeightScaleRequestItemView';
import PendingCommentItemView from 'views/notification/PendingCommentItemView';
import PendingChallengeItemView from 'views/notification/PendingChallengeItemView';
import InboxPageLinkView from 'views/notification/InboxPageLinkView';
import Loadable from 'utils/extensions/Loadable';
import ModelSynchronizer from 'utils/ModelSynchronizer';
import NotificationPoller from 'utils/NotificationPoller';
import ReactComponentView from 'views/main/react/ReactComponentView';
import templateHtml from 'templates/notification/NotificationsPopupMenuView.html';
import BadgeNotification from 'standaloneComponents/BadgeNotification';

import CursorPagedCollection from 'collections/utils/CursorPagedCollection';
import { COUNTED_NOTIFICATION_TYPES, GENERIC_NOTIFICATION_CSS_CLASS } from 'utils/notification/notificationConstants';
import UnreadBubbleDispatcher from 'events/UnreadBubbleDispatcher';
import i18next from 'i18next';
// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';

import 'styles/notificationsPopupMenu.module.css';

i18next.loadNamespaces(['badges-list']);

var Events = {
    REFRESH_COUNT: 'REFRESH_COUNT',
    ON_NAVIGATION: 'ON_NAVIGATION'
};

var LoadableView = Backbone.View.extend(Loadable);

var NotificationsPopupMenuView = LoadableView.extend({
    propertyFiles: [
        '/notification/notification',
        '/privacy_alert/privacy_alert',
        '/activity_types/activity_types',
        '/activity-api/activity-api',
        '/activity/activity',
        '/challengewidget/challengewidget',
        '/email-template/email-template',
        '/connections/connections',
        '/settings/settings',
        '/calendar/calendar',
        '/badges-list/badges-list'
    ],

    template: _.template(templateHtml),

    initialize: function(args) {
        this.displayName = args.displayName;
        this.viewerSocialProfile = args.viewerSocialProfile;
        this.userProfile = args.userProfile;
        this.userPreferences = args.userPreferences;
        this.notificationsLoaded = false;
        this.messageAndDevicesNotificationsEnabled = args.messageAndDevicesNotificationsEnabled;
        this.groupInviteSpammingDays = args.groupInviteSpammingDays;
        this.trainingPlans = args.trainingPlans;

        this.pollTimeoutValue = parseInt(args.pollTimeoutValue, 10);

        this.unviewedCount = 0;
        this.newRequestsCount = 0;
        this.newNotificationsCount = 0;

        this.notifications = new Notifications([], { limit: 50 });
        this.notifications.bind('error', this.defaultErrorHandler, this);

        this.pendingConnections = new PendingConnections();
        this.pendingConnections.bind('error', this.defaultErrorHandler, this);

        this.pendingDeviceInviteRequests = new PendingDeviceInviteRequests();
        this.pendingDeviceInviteRequests.bind('error', this.defaultErrorHandler, this);

        this.pendingChallengeInviteRequests = new PendingChallengeInviteRequests();
        this.pendingChallengeInviteRequests.bind('error', this.defaultErrorHandler, this);

        this.pendingVivokidChallengeRequests = new PendingVivokidChallengeRequests();
        this.pendingVivokidChallengeRequests.bind('error', this.defaultErrorHandler, this);

        this.pendingTeamStepsVivokidChallengeRequests = new PendingTeamStepsVivokidChallengeRequests();
        this.pendingTeamStepsVivokidChallengeRequests.bind('error', this.defaultErrorHandler, this);

        this.inboxRequestCount = new InboxRequestCount();

        this.shouldLoadMoreNotifications = true;
        this.resetNotifications = false;

        // the list to hold notifications that dismiss is in progress
        this.disMissingList = {};

        this.disabledInInboxPage = false;

        //if messageAndDevicesNotificationsEnabled is true then it should allow the notification polling
        if (this.messageAndDevicesNotificationsEnabled) {
            this.unreadBubble = new UnreadBubble();
            this.unreadBubble.bind('error', this.defaultErrorHandler, this);
            this.unreadBubble.bind('hasUnread', this.handleUnreadBubble, this);
            this.disabledInInboxPage = window.location.pathname.includes(NavigationUtil.url('/inbox'));
            UnreadBubbleDispatcher.on(UnreadBubbleDispatcher.Events.ENABLE, () => {
                this.disabledInInboxPage = false;
            });
            this.configurePolling();
        }

        this.openNotificationCallback = args.openNotificationCallback;

        this.gcPlusFrameRole = args.gcPlusFrameRole; // Clean up ticket: CA-165763
    },

    configurePolling: function() {
        if (typeof this.notificationPoller === 'undefined' || this.notificationPoller === null) {
            this.notificationPoller = new NotificationPoller({
                pollTime: this.pollTimeoutValue
            });
        }

        if (this.notificationPoller.isPollingStarted() === false) {
            this.notificationPoller.addCollection(this.unreadBubble);
            this.notificationPoller.start();
        }
    },

    isScrolledIntoView: function(el) {
        let rect = el.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight;
    },

    setupLazyLoader: function() {
        this.$lazyLoad = this.$('.lazyload');

        let container = document.querySelector('.notifications .header-nav-menu');
        container.addEventListener('scroll', this.fetchMoreNotificationsIfNeeded.bind(this));
        if (this.notifications.hasMoreMembers()) this.showLazyLoader();
    },

    hideLazyLoader: function() {
        this.$lazyLoad.hide();
    },

    showLazyLoader: function() {
        this.$lazyLoad.show();
    },

    fetchMoreNotificationsIfNeeded: function() {
        const intoView = this.isScrolledIntoView(this.$lazyLoad[0]);
        if (this.shouldLoadMoreNotifications && intoView) {
            this.fetchMore();
        }
    },

    fetchMore: function() {
        this.shouldLoadMoreNotifications = false;
        let modelSynchronizer = new ModelSynchronizer();
        modelSynchronizer.addEvent({
            model: this.notifications,
            event: CursorPagedCollection.Events.ON_MORE_MEMBERS_FETCHED,
            required: true
        });
        modelSynchronizer.bind(
            ModelSynchronizer.Events.SYNCHRONIZED,
            function() {
                this.shouldLoadMoreNotifications = true;
                let scrolledPosition = document.querySelector('.notifications .header-nav-menu').scrollTop;
                this.renderNotifications(true);
                // reset to previous scrollTop
                document.querySelector('.notifications .header-nav-menu').scrollTop = scrolledPosition;
                if (this.notifications.hasMoreMembers()) {
                    this.showLazyLoader();
                } else {
                    this.hideLazyLoader();
                }
            }.bind(this)
        );
        this.notifications.fetchNext();
    },

    handleNotificationCount: function(model) {
        let counts = model.get('count').counts;

        let countedCount = 0;
        if (Array.isArray(counts)) {
            counts.forEach((countItem) => {
                if (COUNTED_NOTIFICATION_TYPES[countItem.name]) {
                    countedCount += countItem.count;
                }
            });
        }

        // refetch notification list when the unviewedCount changes
        if (countedCount > this.unviewedCount) this.resetNotifications = true;

        if (countedCount !== this.unviewedCount) {
            this.unviewedCount = countedCount;
            this.updateNonViewedMessageCount();
        }
    },

    loadNotificationCounter: function() {
        var modelSynchronizer = new ModelSynchronizer();
        if (this.notificationCount) {
            modelSynchronizer.addModel({
                model: this.notificationCount,
                required: true
            });

            modelSynchronizer.bind(ModelSynchronizer.Events.SYNCHRONIZED, this.onNotificationsCounterFetched, this);

            modelSynchronizer.fetchModels();
        } else if (this.unreadBubble) {
            modelSynchronizer.addModel({
                model: this.unreadBubble,
                required: true
            });

            modelSynchronizer.bind(ModelSynchronizer.Events.SYNCHRONIZED, this.onUnreadBuddleFetched, this);

            modelSynchronizer.fetchModels();
        }
    },

    onNotificationsCounterFetched: function() {
        if (this.notificationCount) {
            this.handleNotificationCount(this.notificationCount);
        }
    },

    handleUnreadBubble: function() {
        this.resetNotifications = true;
        this.updateNonViewedMessageCount(1);
    },

    onUnreadBuddleFetched: function() {
        if (this.unreadBubble && this.unreadBubble.get('unreadBubble')) {
            this.handleUnreadBubble();
        }
    },

    defaultErrorHandler: function(model, error) {
        this.$('.alert-error').show();
        this.$('.empty-state').hide();
        this.log(arguments);
        this.notificationPoller.stopPolling();
    },

    // this function basically reverts what's done in defaultErrorHandler
    resetErrorHandler: function() {
        this.$('.alert-error').hide();
        this.$('.empty-state').show();
        this.notificationPoller.start();
    },

    updateNonViewedMessageCount: function(customCount) {
        if (this.disabledInInboxPage) {
            return;
        }

        let messageCount = _.isNumber(customCount) ? customCount : this.unviewedCount;
        const requestCount = this.inboxRequestCount.get('requestCount');
        const requests = this.inboxRequestCount.get('requests') || [];
        const unread = requests.some((item) => !item.data.requestViewed);
        if (requestCount > 2 && unread) {
            messageCount += 1;
        }
        this.trigger(Events.REFRESH_COUNT, messageCount);
    },

    render: function() {
        const notItemsTitle = Localizer.localize('inbox_is_empty');
        const notItemsDescription = Localizer.localize('inbox_is_empty_description');

        var html = this.template({
            Localizer: Localizer,
            showItems: !this.thereAreNoItems(),
            notificationsLoaded: this.notificationsLoaded,
            inboxUrl: NavigationUtil.url('/inbox'),
            notItemsTitle,
            notItemsDescription
        });

        this.$el.html(html);

        if (this.thereAreNoRequests()) {
            this.$('.requests-header').hide();
        }

        if (this.thereAreNoNotifications()) {
            this.$('.notifications-header').hide();
        }

        if (this.thereAreNoItems()) {
            this.$('.js-no-pending-requests-or-notifications').show();
        } else {
            this.newRequestsCount = 0;
            this.newNotificationsCount = 0;
            this.renderInboxRequests();
            this.renderNotifications();
            this.toggleNewItemsCount();
            this.resetViewedItems();
            this.updateNonViewedMessageCount(0);
        }
    },

    thereAreNoRequests: function() {
        return this.inboxRequestCount.get('requestCount') === 0;
    },

    thereAreNoNotifications: function() {
        return this.notifications.length === 0;
    },

    thereAreNoItems: function() {
        return this.thereAreNoRequests() && this.thereAreNoNotifications();
    },

    toggleNewItemsCount: function() {
        if (this.newNotificationsCount > 0) {
            this.$('.js-new-notifications-count')
                .html(this.newNotificationsCount)
                .show();
        }
    },

    renderInboxRequests: function() {
        const inboxRequestsCountJSON = this.inboxRequestCount.toJSON();
        const requests = inboxRequestsCountJSON.requests || [];
        let profileInfos = null;

        // Clean up ticket: CA-165763
        if (this.gcPlusFrameRole.featureEnabled()) {
            profileInfos = inboxRequestsCountJSON.profileInfos;
        }

        if (requests.length === 0) {
            return;
        }

        const pendingRequestsContainer = this.$('.js-pending-requests-placeholder');

        if (inboxRequestsCountJSON.requestCount > 2) {
            /**
             * render inbox link
             * */
            const inboxLinkView = new InboxPageLinkView({
                inboxRequestCount: this.inboxRequestCount,
                gcPlusFrameRole: this.gcPlusFrameRole // Clean up ticket: CA-165763
            });
            inboxLinkView.render();
            pendingRequestsContainer.append(inboxLinkView.$el);
            return;
        }

        const connectionRequests = [];
        const groupRequests = [];
        const challengeRequests = [];
        const deviceRequests = [];

        for (let idx = 0; idx < requests.length; idx += 1) {
            /**
             * @type {{ requestKey: number; data: any }}
             */
            const request = requests[idx];

            let jsClassName = `js-pending-`;

            switch (request.requestKey) {
                case REQUEST_KEY.CONNECTION_REQUEST:
                    jsClassName += `connection-${request.data.connectionRequestId}`;
                    connectionRequests.push([jsClassName, request]);
                    break;
                case REQUEST_KEY.GROUP_JOIN_REQUEST:
                    jsClassName += `group-${request.data.groupMemberRequestId}`;
                    groupRequests.push([jsClassName, request]);
                    break;
                case REQUEST_KEY.GROUP_INVITE:
                    jsClassName += `group-${request.data.groupInviteId}`;
                    groupRequests.push([jsClassName, request]);
                    break;
                case REQUEST_KEY.ADHOC_INVITE:
                case REQUEST_KEY.KIDADHOC_INVITE:
                case REQUEST_KEY.KIDTEAM_INVITE:
                    jsClassName += `challenge-invite-${request.data.challengeInviteId}`;
                    challengeRequests.push([jsClassName, request]);
                    break;
                case REQUEST_KEY.DEVICE_INVITE:
                    jsClassName += `device-invite-${request.data.deviceInviteId}`;
                    deviceRequests.push([jsClassName, request]);
                    break;
                default:
                    jsClassName = '';
                    break;
            }
            if (!jsClassName) {
                continue;
            }
            const classNames = ['header-nav-menu-section request-item', jsClassName];
            if (!request.data.requestViewed) {
                classNames.push('unread');
            }
            /** append placeholder */
            pendingRequestsContainer.append(`<div class="${classNames.join(' ')}"></div>`);
        }

        /** now, rendering */
        connectionRequests.forEach((item) => {
            const [jsClassName, request] = item;
            const pendingConnectionItemView = new PendingConnectionItemView({
                el: this.$(`.${jsClassName}`),
                pendingConnection: request.data,
                userProfile: this.userProfile,
                userPreferences: this.userPreferences,
                openNotificationCallback: this.openNotificationCallback,
                profileInfos
            });
            this.listenTo(pendingConnectionItemView, PendingConnectionItemView.Events.CONNECTION_CLICKED, function() {
                this.trigger(Events.ON_NAVIGATION);
            });
            pendingConnectionItemView.render();
        });
        groupRequests.forEach((item) => {
            const [jsClassName, request] = item;
            const pendingGroupRequestItemView = new PendingGroupRequestItemView({
                el: this.$(`.${jsClassName}`),
                pendingConnection: request.data,
                userProfile: this.userProfile,
                userPreferences: this.userPreferences,
                groupInviteSpammingDays: this.groupInviteSpammingDays,
                profileInfos
            });
            this.listenTo(pendingGroupRequestItemView, PendingGroupRequestItemView.Events.ON_NAVIGATION, function() {
                this.trigger(Events.ON_NAVIGATION);
            });
            pendingGroupRequestItemView.render();
        });
        deviceRequests.forEach((item) => {
            const [jsClassName, request] = item;
            if (request.deviceInviteStatus === PendingWeightScaleRequestItemView.STATUS.ACCEPTED) {
                return;
            }
            const pendingDeviceInviteRequest = new DeviceInviteRequest(request.data);
            const pendingDeviceInviteRequestItemView = new PendingWeightScaleRequestItemView({
                el: this.$(`.${jsClassName}`),
                pendingDeviceInviteRequest: pendingDeviceInviteRequest,
                userProfile: this.userProfile,
                userPreferences: this.userPreferences,
                profileInfos
            });
            this.listenTo(
                pendingDeviceInviteRequestItemView,
                PendingWeightScaleRequestItemView.Events.ON_NAVIGATION,
                function() {
                    this.trigger(Events.ON_NAVIGATION);
                }
            );
            pendingDeviceInviteRequestItemView.render();
        });
        challengeRequests.forEach((item) => {
            const [jsClassName, request] = item;
            const pendingChallengeItemView = new PendingChallengeItemView({
                el: this.$(`.${jsClassName}`),
                inboxRequest: request.data,
                profileInfos
            });
            this.listenTo(pendingChallengeItemView, PendingChallengeItemView.Events.ON_NAVIGATION, function() {
                this.trigger(Events.ON_NAVIGATION);
            });
            pendingChallengeItemView.render();
        });

        if (this.gcPlusFrameRole.featureEnabled()) {
            this.$('.request-image img.avatar').each((_, element) => {
                let styleString = 'box-shadow: none;';
                const noclip = profileImageHelperV2.isNoclipProfile(element.src);
                if (noclip) {
                    styleString = styleString + 'border-radius:0 !important';
                }
                element.style = styleString;
            });
        }
    },

    renderNotifications: function(empty = false) {
        if (empty) {
            this.$('.js-pending-notifications-placeholder').empty();
        }
        var commentPlaceholder = 0;
        //Let's format the notifications
        var pendingCommentContainer = this.$('.js-pending-notifications-placeholder');
        this.notifications.each(function(notification) {
            if (GENERIC_NOTIFICATION_CSS_CLASS[notification.get('type')]) {
                pendingCommentContainer.append(
                    "<div class='header-nav-menu-section notification-item " +
                        GENERIC_NOTIFICATION_CSS_CLASS[notification.get('type')] +
                        '-notification js-pending-comment-' +
                        commentPlaceholder +
                        "'></div>"
                );
                var containerElement = this.$('.js-pending-comment-' + commentPlaceholder);
                if (!notification.get('viewed')) {
                    containerElement.addClass('unread');
                    this.newNotificationsCount++;
                }

                if (GENERIC_NOTIFICATION_CSS_CLASS[notification.get('type')] === 'badge') {
                    this.renderBadgeNotification(notification, containerElement);
                } else {
                    notification.bind('error', this.defaultErrorHandler, this);
                    this.renderGenericNotification(notification, containerElement);
                }

                commentPlaceholder++;
            }
        }, this);

        this.setupLazyLoader();
    },

    renderGenericNotification: function(notification, containerElement) {
        var pendingCommentItemView = new PendingCommentItemView({
            el: containerElement,
            pendingComment: notification.toJSON(),
            displayName: this.displayName,
            addToList: (id, callback) => this.addToList(id, callback),
            removeFromList: (id) => this.removeFromList(id),
            trainingPlans: this.trainingPlans
        });

        this.listenTo(pendingCommentItemView, PendingCommentItemView.Events.COMMENT_CLICKED, function() {
            this.trigger(Events.ON_NAVIGATION);
        });
        this.listenTo(pendingCommentItemView, PendingCommentItemView.Events.NOTIFICATION_DISMISSED, (id) => {
            this.notifications.remove(id);
            if (this.thereAreNoNotifications()) {
                this.render(); // to render the empty state view after the very last notification got dismissed
            }
        });
        this.listenTo(pendingCommentItemView, PendingCommentItemView.Events.NOTIFICATION_FILTERED, (id) => {
            this.notifications.remove(id);
            this.render();
        });

        this.listenTo(pendingCommentItemView, PendingCommentItemView.Events.NOTIFICATION_DISMISS_UNDO_SUCCESS, () => {
            this.resetErrorHandler();
        });
        this.listenTo(pendingCommentItemView, PendingCommentItemView.Events.NOTIFICATION_DISMISS_UNDO_FAIL, () => {
            this.defaultErrorHandler();
        });
        pendingCommentItemView.render();
    },

    renderBadgeNotification: function(notification, containerElement) {
        this.reactBadgeNotification = new ReactComponentView();
        this.reactBadgeNotification.renderComponent(BadgeNotification, containerElement[0], {
            badgeNotification: notification.toJSON(),
            displayName: this.displayName,
            viewerSocialProfile: this.viewerSocialProfile.toJSON(),
            onSlideUp: () => containerElement.slideUp(),
            onNotificationDismiss: (id) => this.notifications.remove(id),
            onError: () => this.defaultErrorHandler(),
            onResetError: () => this.resetErrorHandler(),
            addToList: (id, callback) => this.addToList(id, callback),
            removeFromList: (id) => this.removeFromList(id)
        });
    },

    provideDependencies: function(modelSynchronizer) {
        // refetch notifications
        if (this.resetNotifications) {
            this.notificationsLoaded = false;
            this.notifications = new Notifications([], { limit: 50 });
            this.notifications.bind('error', this.defaultErrorHandler, this);
            // reset scroll to top
            document.querySelector('.notifications .header-nav-menu').scrollTop = 0;
            this.shouldLoadMoreNotifications = true;
            this.resetNotifications = false;
        } else {
            this.notifications.forEach((notification) => {
                // set viewed to true before render
                notification.set('viewed', true);
            });
        }

        if (this.notifications.length === 0) {
            modelSynchronizer.addModel({ model: this.notifications, required: true });
        }

        modelSynchronizer.addModel({
            model: this.inboxRequestCount,
            required: true
        });

        this.inboxRequestCount.once('sync', () => {
            if (this.inboxRequestCount.get('requestCount') <= 2) {
                /** when requests count <= 2, clean up unview notification */
                const inboxRequests = new InboxRequests();
                inboxRequests.fetch();
            }
        });
    },

    onDependenciesLoaded: function() {
        this.notificationsLoaded = true;
        this.render();
    },

    resetViewedItems: function() {
        var that = this;

        this.pendingConnections.each(function(pendingConnection) {
            if (!pendingConnection.get('requestViewed')) {
                pendingConnection.save(pendingConnection.attributes, {
                    url: '/userprofile-service/connection/notViewedRequestCount',
                    contentType: 'application/json; charset=utf-8',
                    success: function() {
                        that.unviewedCount--;
                        that.updateNonViewedMessageCount();
                    }
                });
            }
        }, this);

        this.pendingDeviceInviteRequests.each(function(pendingRequest) {
            if (!pendingRequest.get('requestViewed')) {
                const deviceInviteId = pendingRequest.get('deviceInviteId');

                const updateUrl = '/invite-service/invite/' + deviceInviteId + '/view/1';

                pendingRequest.save(
                    {},
                    {
                        isRequestViewed: true,
                        url: updateUrl,
                        contentType: 'application/json; charset=utf-8',
                        success: function() {
                            that.unviewedCount--;
                            that.updateNonViewedMessageCount();
                        }
                    }
                );
            }
        }, this);

        this.notifications.each(function(notification) {
            if (!notification.get('viewed')) {
                that.unviewedCount--;
                that.updateNonViewedMessageCount();
            }
        }, this);
    },

    handleDropdownClosed: function() {
        for (const key in this.disMissingList) {
            const callbackFunc = this.disMissingList[key];
            callbackFunc();
        }
        // empty out the list
        this.disMissingList = {};
        this.$('.js-pending-notifications-placeholder .unread').removeClass('unread');
    },

    addToList: function(id, callback) {
        this.disMissingList[id] = callback;
    },

    removeFromList: function(id) {
        delete this.disMissingList[id];
    },

    log: function() {
        if (typeof console !== 'undefined' && typeof console.log !== 'undefined') {
            console.log(arguments);
        }
    }
});

NotificationsPopupMenuView.Events = Events;
export default NotificationsPopupMenuView;
